<template>
    <div class="flex-page">
        <a-form class="ctrl" layout="inline">

            <a-form-item style="float: right;">
                <a-button type="primary" @click="showTuijianren">推荐人管理</a-button>
            </a-form-item>

            <a-form-item label="排序方式">
                <a-radio-group>

                </a-radio-group>
                <a-radio-group v-model="search.orderType" @change="doSearch">
                    <a-radio :value="'id'">编号</a-radio>
                    <a-radio :value="'admin_gongxian'">贡献值</a-radio>
                </a-radio-group>

            </a-form-item>

            <a-form-item label="姓名">
                <a-input style="min-width: 200px" v-model="search.name" placeholder="请输入姓名关键词"></a-input>
            </a-form-item>
            <a-form-item label="电话">
                <a-input style="min-width: 200px" v-model="search.mobile" placeholder="请输入电话关键词"></a-input>
            </a-form-item>

            <a-form-item label="状态">
                <a-select v-model="search.status" style="min-width: 100px">
                    <a-select-option :value="-100">全部</a-select-option>
                    <a-select-option :value="0">未审核</a-select-option>
                    <a-select-option :value="1">已通过</a-select-option>
                    <a-select-option :value="-1">已拒绝</a-select-option>
                    <a-select-option :value="-2">已禁用</a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item label="是否过期">
                <a-select v-model="search.isGuoqi" style="min-width: 100px">
                    <a-select-option :value="-100">全部</a-select-option>
                    <a-select-option :value="1">已过期</a-select-option>
                    <a-select-option :value="0">未过期</a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item>
                <a-button type="primary" @click="doSearch">搜索</a-button>
            </a-form-item>
        </a-form>

        <div class="article-page" style="overflow: auto;">
            <div class="list">
                <div class="statistics">共{{ amount }}条</div>
                <a-table bordered :dataSource="list" :columns="columns" :pagination="false" size="small"
                    :rowKey="(record) => record.id">

                    <template slot="weixin" slot-scope="text, record">
                        <img style="width: 40px;" :src="record.headimgurl" alt="">
                    </template>
                    <template slot="guoqi" slot-scope="text, record">
                        <!-- <div v-if="record.daoqi_at >= guoqi_time"> 未过期</div>
                        <div v-else>已过期</div> -->
                        <div v-if="record.daoqi_at >= guoqi_time"> {{ moment(record.daoqi_at).format("YYYY-MM-DD") }}</div>
                        <div v-else-if="record.daoqi_at">{{ moment(record.daoqi_at).format("YYYY-MM-DD") }}(已过期)</div>
                    </template>

                    <template slot="zhuangtai" slot-scope="text, record">
                        <span v-if="record.status == 0">未审核</span>
                        <span v-if="record.status == 1">已通过</span>
                        <span v-if="record.status == -1">已拒绝</span>
                        <span v-if="record.status == -2">已禁用</span>
                    </template>
                    <template slot="caozuo" slot-scope="text, record">
                        <a-button size="small" @click="shenpi(record)" type="primary"> 审批 </a-button>

                        <a-popconfirm v-if="record.status != -2" title="确定要禁用吗" @confirm="jinyong(record.id, -2)"
                            okText="确定" cancelText="取消">
                            <a-button style="margin-left: 5px" type="danger" size="small">
                                禁用
                            </a-button>
                        </a-popconfirm>

                        <a-popconfirm v-if="record.status == -2" title="确定要恢复吗？ 恢复后将进入未审批状态"
                            @confirm="jinyong(record.id, 0)" okText="确定" cancelText="取消">
                            <a-button style="margin-left: 5px" type="primary" size="small">
                                恢复
                            </a-button>
                        </a-popconfirm>

                        <a-popconfirm v-if="record.status == 0" title="确定要拒绝吗" @confirm="jinyong(record.id, -1)" okText="确定"
                            cancelText="取消">
                            <a-button style="margin-left: 5px" type="danger" size="small">
                                拒绝
                            </a-button>
                        </a-popconfirm>

                        <a-button style="margin-left: 5px" size="small" @click="toBianji(record.id)" type="primary"> 编辑
                        </a-button>

                        <a-button style="margin-left: 5px" size="small" @click="toDetail(record.id)" type="primary"> 详情
                        </a-button>

                        <a-popconfirm v-if="record.daoqi_at >= guoqi_time" title="确定要设为过期吗"
                            @confirm="changeGuoqi(record.id, -1)" okText="确定" cancelText="取消">
                            <a-button style="margin-left: 5px" size="small" type="danger"> 设为过期 </a-button>
                        </a-popconfirm>

                        <a-popconfirm v-else title="确定要设为未过期吗" @confirm="changeGuoqi(record.id, 1)" okText="确定"
                            cancelText="取消">
                            <a-button style="margin-left: 5px" size="small" type="primary"> 设为未过期 </a-button>
                        </a-popconfirm>

                    </template>
                </a-table>
                <a-pagination @change="onChange" :total="amount" :defaultPageSize="50" :defaultCurrent="search.now_page"
                    showQuickJumper class="margin15" />
            </div>
        </div>

        <a-modal title="资格审批" :visible="shenpiData.show" @ok="handleOk" @cancel="handleCancel">
            <a-form class="" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-form-item label="身份">
                    <a-checkbox-group v-model="shenpiData.shenfenArr" :options="shenfenList" />
                </a-form-item>

                <a-form-item label="自我介绍">
                    <a-textarea :auto-size="{ minRows: 13, maxRows: 15 }" v-model="shenpiData.remarks"></a-textarea>
                </a-form-item>

                <a-form-item label="城员等级">
                    <a-select v-model="shenpiData.level">
                        <a-select-option v-for="(item, key) in levelList" :key="key" :value="item"> {{ item
                        }}</a-select-option>
                    </a-select>
                </a-form-item>

                <!-- <a-form-item label="成员积分">
                    <a-input-number v-model="shenpiData.admin_gongxian" :min="0"></a-input-number>
                </a-form-item> -->
            </a-form>
        </a-modal>

        <a-modal title="推荐人管理" :visible="tuijianren.show" @ok="addTuijianren" @cancel="cancelTuijianren">
            <a-form class="form" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-form-item label="推荐人">
                    <a-textarea v-model="tuijianren.data" :auto-size="{ minRows: 4, maxRows: 4 }"></a-textarea>
                    <div><span style="color: red">*</span>以"|"分割</div>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
  
<style lang='scss' scoped></style>
  
<script>
import moment from 'moment'
export default {
    data() {
        return {
            formItemLayout: {
                labelCol: {
                    span: 4,
                },
                wrapperCol: {
                    span: 20,
                },
            },
            columns: [
                {
                    title: "编号",
                    dataIndex: "id",
                },
                {
                    title: "姓名",
                    dataIndex: "name",
                },
                {
                    title: "微信昵称",
                    dataIndex: "nickname",

                },

                {
                    title: "头像",
                    scopedSlots: {
                        customRender: "weixin",
                    },

                },
                {
                    title: "电话",
                    dataIndex: "mobile",
                },
                {
                    title: "城市",
                    dataIndex: "city",
                },
                {
                    title: "推荐人",
                    dataIndex: "tuijianren",
                },
                {
                    title: "身份",
                    dataIndex: "shenfenShow",
                },
                {
                    title: "等级",
                    dataIndex: "level",
                },

                {
                    title: "贡献值",
                    dataIndex: "gongxian_all",
                },

                {
                    title: "有效期",
                    dataIndex: "guoqi",
                    scopedSlots: {
                        customRender: "guoqi",
                    },
                },

                {
                    title: "状态",
                    dataIndex: "zhuangtai",
                    scopedSlots: {
                        customRender: "zhuangtai",
                    },
                },
                {
                    title: "操作",
                    dataIndex: "caozuo",
                    scopedSlots: {
                        customRender: "caozuo",
                    },
                },
            ],
            search: {
                orderType: 'id',
                name: "",
                mobile: "",
                now_page: 1,
                status: -100,
                isGuoqi: -100
            },
            amount: 0,
            pages: 1,
            list: [],
            levelList: ['2018城员', '钻石城员', '金城员', '银城员', '游客'],
            shenfenList: ['贝商', '爱好者', '贝类科研人员'],
            shenpiData: {
                show: false,
                shenfenArr: [],
                remarks: '',
                id: '',
                level: '游客'
                // admin_gongxian: 0

            },
            tuijianren: {
                show: false,
                data: ''
            },
            guoqi_time: moment().startOf('Y').valueOf()


        };
    },
    watch: {

    },
    async created() {
        this.getList();
    },
    mounted() {
    },
    methods: {
        moment,
        doSearch() {
            this.search.now_page = 1;
            this.getList();
        },
        async getList() {
            const r = await this.$axios.get("/shellCity/getApplyList", { params: this.search });
            for (let item of r.list) {
                item.gongxian_all = item.gongxian + item.admin_gongxian
            }
            this.list = r.list;
            this.amount = r.amount;
        },
        onChange(e) {
            this.search.now_page = e;
            this.getList();
        },
        shenpi(record) {
            this.shenpiData.shenfenArr = JSON.parse(record.shenfen)
            this.shenpiData.id = record.id
            this.shenpiData.remarks = record.remarks
            this.shenpiData.level = record.level
            this.shenpiData.show = true
        },
        handleCancel() {
            this.shenpiData.show = false
        },
        async handleOk() {
            const params = JSON.parse(JSON.stringify(this.shenpiData))
            params.shenfenArr = JSON.stringify(params.shenfenArr)
            const r = await this.$axios.post("/shellCity/doShenpi", params);
            if (r.status == 1) {
                // this.$message.success('操作成功')
                this.getList()
                this.shenpiData.show = false
            } else {
                this.$message.error('操作失败')
            }
        },
        async jinyong(id, status) {
            const r = await this.$axios.post("/shellCity/doJinyong", {
                id: id,
                status: status,
            });
            if (r.status == 1) {
                // this.$message.success('操作成功')
                this.getList();
            } else {
                this.$message.error('操作失败...')
            }
        },
        async showTuijianren() {
            const res = await this.$axios.get('/shellCity/getTuijianren')
            if (res.tuijianren) {
                this.tuijianren.data = res.tuijianren
            }
            this.tuijianren.show = true
        },
        async addTuijianren() {
            const res = await this.$axios.post('/shellCity/addTuijianren', this.tuijianren)
            // console.log(res)
            if (res.status == 1) {
                // this.$message.success('操作成功')
                this.cancelTuijianren()
            } else {
                this.$message.error('操作失败...')
            }
        },
        cancelTuijianren() {
            this.tuijianren.show = false
        },
        toBianji(id) {
            this.$router.push('/shellCity/edit?id=' + id)
        },
        toDetail(id) {
            this.$router.push('/shellCity/detail?id=' + id)
        },
        async changeGuoqi(id, type) {
            const r = await this.$axios.post('/shellCity/changeGuoqi', { id: id, type: type })
            if (r.status == 1) {
                // this.$message.success('操作成功')
                this.getList()
            }
        }
    },
};
</script>
  
<style></style>
